var startTime = window.performance.now();

function retrieveLocation() {
  var selectedLocation = $(
    "input[type='radio'][name='location_id']:checked"
  ).val();
  let locationTimeoutID;
  var lastLocation = document.cookie
    .split("; ")
    .find((row) => row.startsWith("zapietlocation="))
    ?.split("=")[1];
  if (lastLocation != "" && selectedLocation != lastLocation) {
    if ($("#location_" + lastLocation).length == 1) {
      $("#location_" + lastLocation).click();
      if ($(".locations").scrollTop() == 0) {
        var scrollTo = $("#location_" + lastLocation).position().top;
        $(".locations").scrollTop(scrollTo);
      }
      clearTimeout(locationTimeoutID);
    } else {
      locationTimeoutID = setTimeout(retrieveLocation, 1000);
    }
  }
}

jQuery(function () {
  load_owlCarousel();

  $("body").on("change", ".locationRadio", function () {
    var $location = $(this).val();
    document.cookie =
      "zapietlocation=" + $location + "; SameSite=None; max-age=86400; Secure";
  });

  window.ZapietEvent.listen("pickup.datepicker.rendered", function () {
    retrieveLocation();
  });

  $(".testimonial-rotator").flexslider({
    animation: "fade",
  });
  $(".location-image-gallery").flexslider({
    animation: "fade",
    slideshow: true,
    touch: true,
  });

  // Dropdown click/hover/keyboard handling moved to timber.accessibleNav.

  $("body").on("click", function (event) {
    $("#log").html("clicked: " + event.target.nodeName);
  });

  if ($(".collection-sidebar__title").text() == "Weight Loss") {
    $("#sorting-hat").val("cal-low");
    sortCollectionByCustom("cal-low");
  }

jQuery(document).on('submit', '#zapiet-delivery-validator__form', function(e) {
    var validatorInterval = setInterval(() => {
        var validatorNote = document.querySelector('#zapiet-delivery-validator__modal__container__content');
        if (validatorNote) {
          var validatorHeader = document.querySelector('#zapiet-delivery-validator__modal__container__heading');
          if (validatorHeader.textContent === 'Great, we deliver to your area!') {
            validatorNote.innerHTML = '<p style="font-weight: normal">Online orders require <strong style="color: #c00;">72 hours notice</strong> for pickup or delivery. Meals are always available on demand at any of our retail locations. For more details, visit our <a href="https://fit-flavors.com/pages/how-it-works" target="blank">How It Works</a> and <a href="https://fit-flavors.com/pages/locations">Locations</a> pages.</p>';
            clearInterval(validatorInterval);
          }
        }
      }, 100);

      var timeoutId = setTimeout(() => {
        clearInterval(validatorInterval);
    }, 10000); // 10 seconds
});

  $(".nfo-anchor").fancybox({
    transitionIn: "none",
    transitionOut: "none",
  });

  $("a#fancybox-home-video").fancybox({
    afterShow: function () {
      // $('#fitUVideoPlayer').trigger('play');
      $("#fitUVideoIframe")[0].contentWindow.postMessage(
        '{"event":"command","func":"' + "playVideo" + '","args":""}',
        "*"
      );
    },
    beforeClose: function () {
      $("#fitUVideoIframe")[0].contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
      // $('#fitUVideoPlayer').trigger('pause');
    },
  });
});

/*
 * jquery-match-height 0.7.2 by @liabru
 * http://brm.io/jquery-match-height/
 * License MIT
 */
!(function (t) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], t)
    : "undefined" != typeof module && module.exports
    ? (module.exports = t(require("jquery")))
    : t(jQuery);
})(function (t) {
  var e = -1,
    o = -1,
    n = function (t) {
      return parseFloat(t) || 0;
    },
    a = function (e) {
      var o = 1,
        a = t(e),
        i = null,
        r = [];
      return (
        a.each(function () {
          var e = t(this),
            a = e.offset().top - n(e.css("margin-top")),
            s = r.length > 0 ? r[r.length - 1] : null;
          null === s
            ? r.push(e)
            : Math.floor(Math.abs(i - a)) <= o
            ? (r[r.length - 1] = s.add(e))
            : r.push(e),
            (i = a);
        }),
        r
      );
    },
    i = function (e) {
      var o = {
        byRow: !0,
        property: "height",
        target: null,
        remove: !1,
      };
      return "object" == typeof e
        ? t.extend(o, e)
        : ("boolean" == typeof e
            ? (o.byRow = e)
            : "remove" === e && (o.remove = !0),
          o);
    },
    r = (t.fn.matchHeight = function (e) {
      var o = i(e);
      if (o.remove) {
        var n = this;
        return (
          this.css(o.property, ""),
          t.each(r._groups, function (t, e) {
            e.elements = e.elements.not(n);
          }),
          this
        );
      }
      return this.length <= 1 && !o.target
        ? this
        : (r._groups.push({ elements: this, options: o }),
          r._apply(this, o),
          this);
    });
  (r.version = "0.7.2"),
    (r._groups = []),
    (r._throttle = 80),
    (r._maintainScroll = !1),
    (r._beforeUpdate = null),
    (r._afterUpdate = null),
    (r._rows = a),
    (r._parse = n),
    (r._parseOptions = i),
    (r._apply = function (e, o) {
      var s = i(o),
        h = t(e),
        l = [h],
        c = t(window).scrollTop(),
        p = t("html").outerHeight(!0),
        u = h.parents().filter(":hidden");
      return (
        u.each(function () {
          var e = t(this);
          e.data("style-cache", e.attr("style"));
        }),
        u.css("display", "block"),
        s.byRow &&
          !s.target &&
          (h.each(function () {
            var e = t(this),
              o = e.css("display");
            "inline-block" !== o &&
              "flex" !== o &&
              "inline-flex" !== o &&
              (o = "block"),
              e.data("style-cache", e.attr("style")),
              e.css({
                display: o,
                "padding-top": "0",
                "padding-bottom": "0",
                "margin-top": "0",
                "margin-bottom": "0",
                "border-top-width": "0",
                "border-bottom-width": "0",
                height: "100px",
                overflow: "hidden",
              });
          }),
          (l = a(h)),
          h.each(function () {
            var e = t(this);
            e.attr("style", e.data("style-cache") || "");
          })),
        t.each(l, function (e, o) {
          var a = t(o),
            i = 0;
          if (s.target) i = s.target.outerHeight(!1);
          else {
            if (s.byRow && a.length <= 1) return void a.css(s.property, "");
            a.each(function () {
              var e = t(this),
                o = e.attr("style"),
                n = e.css("display");
              "inline-block" !== n &&
                "flex" !== n &&
                "inline-flex" !== n &&
                (n = "block");
              var a = {
                display: n,
              };
              (a[s.property] = ""),
                e.css(a),
                e.outerHeight(!1) > i && (i = e.outerHeight(!1)),
                o ? e.attr("style", o) : e.css("display", "");
            });
          }
          a.each(function () {
            var e = t(this),
              o = 0;
            (s.target && e.is(s.target)) ||
              ("border-box" !== e.css("box-sizing") &&
                ((o +=
                  n(e.css("border-top-width")) +
                  n(e.css("border-bottom-width"))),
                (o += n(e.css("padding-top")) + n(e.css("padding-bottom")))),
              e.css(s.property, i - o + "px"));
          });
        }),
        u.each(function () {
          var e = t(this);
          e.attr("style", e.data("style-cache") || null);
        }),
        r._maintainScroll &&
          t(window).scrollTop((c / p) * t("html").outerHeight(!0)),
        this
      );
    }),
    (r._applyDataApi = function () {
      var e = {};
      t("[data-match-height], [data-mh]").each(function () {
        var o = t(this),
          n = o.attr("data-mh") || o.attr("data-match-height");
        n in e ? (e[n] = e[n].add(o)) : (e[n] = o);
      }),
        t.each(e, function () {
          this.matchHeight(!0);
        });
    });
  var s = function (e) {
    r._beforeUpdate && r._beforeUpdate(e, r._groups),
      t.each(r._groups, function () {
        r._apply(this.elements, this.options);
      }),
      r._afterUpdate && r._afterUpdate(e, r._groups);
  };
  (r._update = function (n, a) {
    if (a && "resize" === a.type) {
      var i = t(window).width();
      if (i === e) return;
      e = i;
    }
    n
      ? o === -1 &&
        (o = setTimeout(function () {
          s(a), (o = -1);
        }, r._throttle))
      : s(a);
  }),
    t(r._applyDataApi);
  var h = t.fn.on ? "on" : "bind";
  t(window)[h]("load", function (t) {
    r._update(!1, t);
  }),
    t(window)[h]("resize orientationchange", function (t) {
      r._update(!0, t);
    });
});

/*

Flow by WeTheme (http://www.wetheme.com)
Custom JS

*/

/* Mapping from sectionId to Slider instance */
var sliders = {};

function block_select(event) {
  // Stop animation and show block when selected in the Slideshow section
  var slider = sliders[event.detail.sectionId];
  if (slider) {
    var index = parseInt(event.target.dataset.slideIndex);
    slider.show_slide(index);
  }
}

function block_deselect(event) {
  // Resume animation when block is deselected in the Slideshow section
  var slider = sliders[event.detail.sectionId];
  if (slider) {
    slider.start_animation();
  }
}

function get_section_name(event) {
  var section = null;
  if (event && event.detail) {
    var data = {};
    var dataset = event.target.dataset;
    for (var key in dataset) {
      if (
        dataset.hasOwnProperty(key) &&
        key.indexOf("themeEditorSection-") === 0
      ) {
        data = JSON.parse(dataset[key]);
      }
    }
    if (data.hasOwnProperty("type")) {
      section = data["type"];
    }
  }
  return section;
}

document.addEventListener("shopify:section:load", load_all);
document.addEventListener("shopify:section:unload", unload_all);
window.addEventListener("load", load_all);

// Run the fade in animation as soon as possible, don't wait for full content load
$(document).ready(function () {
  load_show_on_scroll();

  $(".pill").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("selected");
  });
});

function load_all(event) {
  document.addEventListener("shopify:block:select", block_select);
  document.addEventListener("shopify:block:deselect", block_deselect);

  var section = get_section_name(event);

  if (!section || section === "products-block") {
    load_homepage_fading();
    load_featured_masonry();
  }
  load_blog_masonry();
  if (!section || section === "slideshow") {
    // Do not reload slider when header or footer is changed
    load_slider(event && event.target);
  }
  if (!section || section === "featured-blog") {
    load_carousel();
  }
  if (!section || section === "text-adverts") {
    load_TextAdvertCarousel();
  }
  if (!section || section === "product-template") {
    load_swatches();
    load_reviews();
    load_imageZoomEvents();
  }
  if (!section || section === "indiv-product") {
    load_indiv_product_slider();
    load_product_review_badges();
  }
  if (
    !section ||
    section === "product-template" ||
    section === "indiv-product"
  ) {
    load_quantity_selector();
    load_option_selectors(event.target);
    load_tabs();
  }
  if (!section || section === "header") {
    load_accessible_menu();
    load_sticky();
    load_log_in();
    load_search_drawer();
  }
  if (!section || section === "instagram") {
    load_instagram();
  }
  if (!section || section === "collection-list") {
    load_home_collection();
  }
  if (!section || section === "products-block") {
    load_product_block();
  }
  if (!section || section === "home-hero" || section === "video") {
    load_youtube_api();
    load_vimeo_api();
  }
  if (!section || section === "home-hero") {
    load_hero();
  }
  if (
    !section ||
    section === "feature-row" ||
    section === "image-with-text-overlay"
  ) {
    load_parallax();
  }
  if (!section || section === "collection-template") {
    load_collection_tag_filter();
    load_infinite_scroll();
    load_product_review_badges();
  }
  if (!section || section === "featured-products") {
    load_product_review_badges();
  }
  if (
    !section ||
    section === "collection-template" ||
    section === "featured-products" ||
    section === "product-template"
  ) {
    load_shop_now();
  }
  if (!section) {
    load_drawer_sticky_menu();
  } else {
    load_show_on_scroll();
  }

  //Close drawers when clicked on drawer overlay
  $("#DrawerOverlay")
    .off("click")
    .on("click", function (evt) {
      if (timber.LeftDrawer.drawerIsOpen) {
        timber.LeftDrawer.close();
        evt.stopImmediatePropagation();
      }
      if (timber.RightDrawer.drawerIsOpen) {
        timber.RightDrawer.close();
        evt.stopImmediatePropagation();
      }
    });

  // Hide mobile search bar when disabled
  var has_search = $(".search-button").length > 0;
  $(".input-group.search-bar").toggle(has_search);
}

function unload_all() {
  document.removeEventListener("shopify:block:select", block_select);
  document.removeEventListener("shopify:block:deselect", block_deselect);
  sliders = {};
}

// Show on scroll animation
function load_show_on_scroll() {
  $(window).on("scroll", function () {
    show_on_scroll_checker();
  });
  show_on_scroll_checker();

  new WOW().init();
}

function show_on_scroll_checker() {
  var window_height = $(window).height();
  $(".show-on-scroll").each(function (index, section) {
    var rect = section.getBoundingClientRect();
    if (rect.bottom >= 0 && rect.top < window_height) {
      $(section)
        .removeClass("show-on-scroll")
        .addClass("shown-on-scroll animated fadeIn");
    }
  });
}

// Fading on homepage blocks
function load_homepage_fading() {
  apply_fade_effect(
    ".homepage-featured-products-grid",
    ".homepage-featured-grid-item"
  );
  apply_fade_effect(".collection-grid", ".homepage-collection-grid-item");
}

function apply_fade_effect(parent_selector, child_selector) {
  $(parent_selector).each(function (index, parent) {
    apply_fade_effect_to_element(parent, child_selector);
  });
}

function apply_fade_effect_to_element(element, child_selector) {
  var children = $(element).find(child_selector);

  children.on("mouseenter mouseleave", function (e) {
    children
      .not(this)
      .stop(true)
      .fadeTo("fast", e.type === "mouseenter" ? 0.2 : 1);
  });
}

// Mobile Blog

function load_carousel() {
  $(".homepage-blog-mobile").addClass("owl-carousel owl-theme").owlCarousel({
    items: 1,
    autoHeight: true,
  });

  $("#homepage-collection-mobile")
    .addClass("owl-carousel owl-theme")
    .owlCarousel({
      items: 1,
      autoHeight: true,
    });
}

function load_sticky() {
  var $productSticky = $(".product-sticky.ui.sticky");
  if ($productSticky.length === 0) {
    return;
  }

  var $window = $(window);

  function checkWidth() {
    var windowsize = $window.width();
    if (windowsize > 768) {
      var context = $(".context");

      if (context.height() > $productSticky.height()) {
        var $site_header = $(".site-header");
        var offset = 0;
        if ($site_header.hasClass("sticky-header")) {
          offset = $site_header.outerHeight() || 0;
        }
        $productSticky.sticky({
          context: ".context",
          // We might need offset for custom header
          offset: offset,
          bottomOffset: 50,
          observeChanges: true,
        });
      }
    } else {
    }
  }
  // Execute on load
  checkWidth();
  // Reexecute on page resize
  $(window).resize(checkWidth);
  // Reexecute when product review form opens (it changes page height)
  if ($("#shopify-product-reviews").length >= 0) {
    // The reviews will appear in the future, we need to wait for it
    var wait_for_review = setInterval(function () {
      var review_button = $(".spr-summary-actions-newreview");
      if (review_button.length === 0) {
        return;
      }
      clearInterval(wait_for_review);
      review_button.on("click", function () {
        // Reexecute the sticky
        checkWidth();
      });
    }, 1000);
  }
}

// Quantity Selector

function load_quantity_selector() {
  var $quantity = $(".nonajax-quantity-selector");
  if ($quantity.length === 0) {
    return;
  }

  var $input = $quantity.find("input");

  $quantity.find(".js-qty__adjust--minus").unbind();
  $quantity.find(".js-qty__adjust--plus").unbind();

  $quantity.find(".js-qty__adjust--minus").on("click", function () {
    $(this)
      .siblings("input")
      .val(Math.max(1, parseInt($(this).siblings("input").val()) - 1));
  });
  $quantity.find(".js-qty__adjust--plus").on("click", function () {
    $(this)
      .siblings("input")
      .val(parseInt($(this).siblings("input").val()) + 1);
  });
}

// Load owlCarousel on Product

function load_owlCarousel() {
  var product_images = $("#product-images-mobile");
  if (product_images.length === 0) {
    return;
  }
  var is_shop_now = product_images.closest("#ShopNowContainer").length > 0;

  var options;
  if (is_shop_now) {
    // Shop now
    options = {
      center: true,
      items: 2,
      autoHeight: true,
      dots: true,
    };
  } else {
    // Product Page
    options = {
      items: 1,
      autoHeight: true,
      URLhashListener: true,
      startPosition: "URLHash",
    };
  }

  product_images.owlCarousel(options);
  if (is_shop_now) {
    // Clicking on next and previous item should select it
    $(document).on("click", "#product-images-mobile .owl-item", function () {
      n = $(this).index();
      $("#product-images-mobile").trigger("to.owl.carousel", n);
    });
  } else {
    product_images.on("changed.owl.carousel", function (event) {
      $(".scrollImg").removeClass("active");
      targetIMG = event.item.index + 1;
      $("#scrollImg" + targetIMG).addClass("active");
    });
  }

  owlCarouselPaginationFix(product_images);
  owlCarouselSlowImageLoadFix(product_images);
}

//owl carousel pagination fix
function owlCarouselPaginationFix(product_images) {
  product_images.on(
    "refreshed.owl.carousel changed.owl.carousel",
    function (event) {
      $("#product-images-mobile .owl-dots").each(function (index, ele) {
        if ($(ele).children().length > 1) {
          $(ele).removeClass("disabled");
        }
      });
    }
  );
}

//owl carousel slow image load fix
function owlCarouselSlowImageLoadFix(product_images) {
  product_images.on("refreshed.owl.carousel", function (event) {
    $(this)
      .delay(500)
      .queue(function () {
        //wait for owlCarousel to catch up.

        if ($(".owl-stage-outer", product_images).height() == 1) {
          $(".owl-stage-outer", product_images).css({ height: "auto" });
        }
      });
  });
}

// Load Product

function Product(element) {
  this.element = element;
  if (!this.element) {
    return;
  }
  this.$element = $(this.element);
  this.sectionId = this.element.dataset.sectionId;
  var product_json_el = document.querySelector(
    "#ProductJson-" + this.sectionId
  );
  if (!product_json_el) {
    // No product on the page - maybe just product placeholder
    return;
  }
  this.product = JSON.parse(product_json_el.innerText);
  this.$selects = this.$element.find(".selector-wrapper select");
  this.$selects.on("change", this.on_select_change.bind(this));
  this.$original_select = this.$element.find(".original-select");

  this.on_select_change();
}

Product.prototype.on_select_change = function () {
  var values = this.$selects.map(function (index, select) {
    return $(select).val();
  });
  var matching_variants = this.product.variants.filter(function (variant) {
    for (var i = 0; i < values.length; i++) {
      if (values[i] !== variant.options[i]) {
        return false;
      }
    }
    return true;
  });
  if (matching_variants.length === 0) {
    this.update_variant(null);
  } else {
    this.update_variant(matching_variants[0]);
  }
};

Product.prototype.update_variant = function (variant) {
  timber.productPage({
    money_format: window.Currency
      ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format
      : window.default_currency_format,
    variant: variant,
    element: this.$element,
  });
  if (variant) {
    this.$original_select.val(variant.id);

    var is_indiv_product = $(this.element)
      .closest(".shopify-section")
      .hasClass("homepage-section--indiv-product-wrapper");
    if (history.pushState && !is_indiv_product) {
      // Change url to include variant if we're not on homepage
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    }

    var is_sale =
      variant.compare_at_price && variant.compare_at_price > variant.price;
    $(".product-page--sale-badge").toggleClass("hide", !is_sale);

    if ($(".product-details-wrapper").data("show-sku")) {
      $(".js__currentVariantSKU").text(variant.sku);
      $(".product__meta--sku").toggleClass("hide", !variant.sku);
    }
  }
};

function load_option_selectors(section) {
  var root = section || document;
  Array.prototype.forEach.call(
    root.querySelectorAll(".product-single"),
    function (element) {
      var product = new Product(element);
    }
  );
}

// Product Tabs

function load_tabs() {
  $("ul.tabs").each(function () {
    var active,
      content,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.fadeIn();
        return false;
      });
  });
}

// Load swatches on product page

function load_swatches() {
  // Swatches disabled, function kept in case accidentally called. Code archived
}

// Reload reviews on change in theme admin

function load_spr() {
  // wait for SPR script to be loaded
  var wait_for_review = setInterval(function () {
    if (!window.SPR || !window.SPR.$) {
      return;
    }
    clearInterval(wait_for_review);
    window.SPR.initDomEls();
    window.SPR.loadProducts();
    window.SPR.loadBadges();
  }, 500);
}

function load_reviews() {
  if ($("#shopify-product-reviews").length >= 0) {
    load_spr();
  }
}

// Reload review badges on change in theme admin

function load_product_review_badges() {
  if ($("#shopify-product-reviews-badge").length >= 0) {
    load_spr();
  }
}

// Flexslider in Indiv Product section

function load_indiv_product_slider() {
  var slider = $(".homepage-sections--indiv-product-slider");
  slider.flexslider({
    directionNav: false,
    slideshow: false,
    animation: "slide",
  });

  slider.find("img").removeClass("hide");
}

// Blog Masonry

function load_blog_masonry() {
  var $grid2 = $(".blog-article-wrapper").masonry({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: ".blog-grid-item",
    // use element for option
    columnWidth: ".blog-grid-item",
    gutter: ".blog-gutter-sizer",
    percentPosition: true,
  });
}

// Featured Products Masonry

function load_featured_masonry() {
  var $grid = $(".homepage-featured-products-grid").masonry({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: ".homepage-featured-grid-item",
    // use element for option
    columnWidth: ".homepage-featured-grid-item",
    percentPosition: true,
    gutter: ".gutter-sizer",
  });

  $grid.imagesLoaded().progress(function () {
    $grid.masonry("layout");
  });
}

// Accessible Menu JS
function load_accessible_menu() {
  $(".site-nav").addClass("js");
  $(".site-nav li").hover(
    function () {
      $("ul.site-nav__dropdown", $(this)).fadeIn();
    },
    function () {
      $("ul.site-nav__dropdown", $(this)).fadeOut();
    }
  );
  $(".site-nav li a").focus(function () {
    // main nav anchor focus
    $(this).parent().children("ul").fadeIn();
  });
  $(".site-nav li li a").unbind(); // unbind hide drop downs from sub nav anchors
}

// Sticky page header
// will want to remove reference is custom.js line 613
function load_sticky_header(skip_reload_on_image_load) {
  // doing this a different way now, function kept in case accidentally called, code archived
}

function checkSidebarSticky() {
  if (
    $(window).width() > 768 &&
    $(".collection-sidebar-wrapper").outerHeight(true) <
      $(window).height() - 200
  ) {
    $(".collection-sidebar-wrapper").addClass("sticky-ok");
  } else {
    $(".collection-sidebar-wrapper").removeClass("sticky-ok");
  }
}

$(window).resize(function () {
  checkSidebarSticky();
});

window.addEventListener("scroll", checkHeaderPos);

function checkHeaderPos() {
  var headerPos = $("#shopify-section-header").position().top;
  var scroll = $(window).scrollTop();
  var scrolltop = $("#shopify-section-announcement-bar").height();
  var scrolltopBuffer = scrolltop;

  if (scroll >= scrolltop) {
    $("#shopify-section-header").addClass("fixed");
    window.removeEventListener("scroll", checkHeaderPos);
  } else if (scroll == 0) {
    // 40 had been here instead of scrolltop
  }
}
// Instagram section

var INSTAGRAM_SELECTOR = ".instagram-wrapper";
var INSTAGRAM_TEMPLATE =
  '<div class="grid__item %grid% homepage-instagram-indiv"><a href="" target="_blank"><img src="https://cdn.shopify.com/s/files/1/2146/8987/files/1x1.png" data-src="" class="lazyload-img img-responsive"/><div class="homepage-instagram-hover"><span class="fa-stack fa-2x"><i class="fa fa-circle fa-stack-2x fa-inverse"></i><i class="fa fa-instagram fa-stack-1x"></i></span></div></a></div>';

var INSTAGRAM_OPTIONS = {
  get: "user",
  userId: "self",
  resolution: "thumbnail",
};

var instagrams = {};

function instagram_init(instagram_element) {
  var section = instagram_element.dataset.id;

  // Read the instagram token
  var token_input = document.querySelector("#token-" + section);
  if (!token_input) {
    // We don't have a token, no data are available and placeholder is shown, just apply fade effect
    apply_fade_effect_to_element(instagram_element, ".grid__item");
    return;
  }
  var token = token_input.value;

  // Set up options for instafeed
  var target = document.querySelector("#instafeed-" + section),
    gridWidth = target.dataset.gridWidth,
    rows = parseInt(target.dataset.rows),
    grid = parseInt(target.dataset.grid);

  var options = $.extend(
    {},
    {
      target: target,
      accessToken: token,
      template: INSTAGRAM_TEMPLATE.replace("%grid%", gridWidth),
      limit: rows * grid,
      error: function (message) {
        console.error("Unable to download instagram data: " + message);
      },
      after: function () {
        Array.prototype.forEach.call(
          target.querySelectorAll("img"),
          function (img) {
            img.src = img.src.replace("/s150x150/", "/s640x640");
          }
        );

        // global method 'apply_fade_effect_to_element' defined in custom.js.liquid
        apply_fade_effect_to_element(target, ".grid__item");
      },
    },
    INSTAGRAM_OPTIONS
  );

  // Remove all previous images
  while (target.firstChild) {
    target.removeChild(target.firstChild);
  }

  // Fetch and show instagram pictures
  var feed = new Instafeed(options);
  feed.run();
}

function load_instagram() {
  var instagram_elements = document.querySelectorAll(INSTAGRAM_SELECTOR);
  Array.prototype.forEach.call(instagram_elements, instagram_init);
}

// Home Collection section

function load_home_collection() {
  var homepageCollection = $(".homepage-collection-grid-item");
  homepageCollection.on("mouseenter mouseleave", function (e) {
    homepageCollection
      .not(this)
      .stop(true)
      .fadeTo("fast", e.type == "mouseenter" ? 0.2 : 1);
  });
}

// Product Block section

function load_product_block() {
  var $grid = $(".homepage-featured-products-grid").masonry({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: ".homepage-featured-grid-item",
    // use element for option
    columnWidth: ".homepage-featured-grid-item",
    percentPosition: true,
    gutter: ".gutter-sizer",
  });

  $grid.imagesLoaded().progress(function () {
    $grid.masonry("layout");
  });
}

function load_youtube(element) {
  var autoplay = element.dataset.homepageHeroVideoAutoplay === "true",
    mute = element.dataset.homepageHeroVideoMute === "true",
    loop = element.dataset.homepageHeroVideoLoop === "true";
  player = new YT.Player(element.id, {
    width: 746,
    videoId: element.dataset.homepageHeroVideoLink,
    playerVars: {
      showinfo: 0,
      modestbranding: 1,
      rel: 0,
    },
    events: {
      onReady: function (event) {
        if (autoplay) {
          event.target.playVideo();
          hideVideoOverlays(element);
        }

        if (mute) {
          event.target.mute();
        }

        registerVideoPlayButton(element, "youtube", player);
      },
      onStateChange: function (event) {
        if (event.data === YT.PlayerState.ENDED && loop) {
          event.target.playVideo();
        }
      },
    },
  });
}

function load_youtube_all() {
  $(".homepage-hero-youtube-video").each(function (index, el) {
    load_youtube(el);
  });
}

function load_youtube_api() {
  if (!document.querySelector(".homepage-hero-youtube-video")) {
    // No youtube elements, do not load youtube API
    return;
  }

  if (!document.querySelector("#youtube_api")) {
    // Youtube API is not yet loaded, create script that loads it
    create_script("youtube_api", "https://www.youtube.com/player_api");

    // Call 'youtube_load_all' as soon as the API is loaded
    window.onYouTubePlayerAPIReady = load_youtube_all;
  } else if (!window.YT) {
    // Script for loading youtube API is there, but youtube is not yet loaded,
    // load_youtube_all will be called when script finishes loading
  } else {
    // We already have youtube API loaded, call 'load_youtube_all'
    load_youtube_all();
  }
}

function load_vimeo(element) {
  var player = new Vimeo.Player(element.id);

  player
    .ready()
    .then(function () {
      registerVideoPlayButton(element, "vimeo", player);

      if (
        document.querySelector("#" + element.id).dataset.vimeoAutoplay ===
        "true"
      ) {
        hideVideoOverlays(element);
      }

      if (
        document.querySelector("#" + element.id).dataset
          .homepageHeroVideoMute === "true"
      ) {
        player.setVolume(0);
      }
    })
    .catch(function (e) {
      document.getElementById(element.id).innerText = e;
    });
}

function load_vimeo_all() {
  $(".homepage-hero-vimeo-video").each(function (index, el) {
    load_vimeo(el);
  });
}

function load_vimeo_api() {
  if (!document.querySelector(".homepage-hero-vimeo-video")) {
    // No vimeo elements, do not load vimeo API
    return;
  }

  if (!document.querySelector("#vimeo_api")) {
    // Vimeo API is not yet loaded, create script that loads it
    var script = create_script(
      "vimeo_api",
      "https://player.vimeo.com/api/player.js"
    );

    if (script.readyState) {
      // IE
      script.onreadystatechange = function () {
        if (
          element.readyState == "loaded" ||
          element.readyState == "complete"
        ) {
          element.onreadystatechange = null;
          load_vimeo_all();
        }
      };
    } else {
      // Other browsers
      script.onload = function () {
        load_vimeo_all();
      };
    }
  } else if (!window.Vimeo) {
    // Script for loading vimeo API is there, but vimeo is not yet loaded,
    // load_vimeo_all will be called when script finishes loading
  } else {
    // We already have vimeo API loaded, call 'load_vimeo_all'
    load_vimeo_all();
  }
}

// register events on the video play button, plays video and hides certain elements.
function registerVideoPlayButton(element, type, player) {
  var videoParent = element.closest(".homepage-hero-content--video");
  var $playButton = $(".homepage-video-play-button", videoParent);

  // bind custom play button events
  $playButton.on("click", function (event) {
    if (type === "youtube") {
      player.playVideo();
    } else if (type === "vimeo") {
      player.play();
    }

    hideVideoOverlays(element);
  });
}

function hideVideoOverlays(videoElement) {
  var videoParent = videoElement.closest(".homepage-hero-content--video");

  // hide some things when we press play.
  $(".js__hide-on-play", videoParent).fadeOut("slow");

  //we need to hide the ::before pseudo-element on the container when we press play.
  $(".homepage-hero-content-overlay-wrapper", videoParent).addClass("hidden");
}

function create_script(id, src) {
  var tag = document.createElement("script");
  tag.id = id;
  tag.src = src;
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  return tag;
}

function hover_effect($link) {
  var $overlay = $("#" + $link.data("overlayId"));
  $link.hover(
    function () {
      $overlay.addClass("active");
    },
    function () {
      $overlay.removeClass("active");
    }
  );

  // Apply hover on page load
  if ($link.is(":hover")) {
    $overlay.addClass("active");
  }
}

function load_hero() {
  $(".homepage-hero-content-overlay-menu-item").imagesLoaded(
    { background: true },
    function () {
      $(".homepage-hero-text-advert-link").each(function (index, link) {
        hover_effect($(link));
      });

      $(".homepage-hero-menu li").each(function (index, link) {
        hover_effect($(link));
      });
    }
  );
}

function load_drawer_sticky_menu() {
  // Fix that scrolling inside drawer propagates to page content on iPad
  // it's an workaround for https://bugs.webkit.org/show_bug.cgi?id=153852
  // can be replaced by setting "overflow: hidden" to js-drawer-open
  // class after the bug is fixed
  var body_scroll = 0;
  $(document.body).on("beforeDrawerOpen.timber", function () {
    if ($(document.body).css("position") === "fixed") {
      return;
    }
    body_scroll = document.body.scrollTop;
    $(document.body).css({
      position: "fixed",
      height: "100%",
      width: "100%",
      overflow: "hidden",
      marginTop: "-" + body_scroll + "px",
    });
    load_sticky();
  });
  $(document.body).on("beforeDrawerClose.timber", function () {
    $(document.body)
      .css({
        position: "static",
        height: "auto",
        width: "auto",
        overflow: "auto",
        marginTop: "0",
      })
      .scrollTop(body_scroll);
    load_sticky();
  });
}

// Slider section

var DEFAULT_OPTIONS = {
  directionNav: true,
  controlNav: false,
  startAt: 0,
};

var SLIDER_SELECTOR = ".flexslider-homepage";
var SLIDER_REENABLE_INTERVAL = 6000;

/* Initialize all the sliders */
function load_slider(section) {
  sliders = {};
  section = section || document;
  var slider_elements = section.querySelectorAll(SLIDER_SELECTOR);
  Array.prototype.forEach.call(slider_elements, function (slider_element) {
    // Prevent flickering in the flexslider by setting fixed width of the slides
    $(slider_element).find("li").css("width", $(slider_element).width());

    sliders[slider_element.dataset.sliderId] = new Slider(slider_element);
  });
}

function Slider(element) {
  this.$element = $(element);
  this.restartTimer = null;
  this.running = true;

  this.get_speed = function () {
    return parseInt(this.$element.data("sliderSlideTime"));
  };

  this.get_animation = function () {
    return this.$element.data("sliderAnimation");
  };

  this.show_slide = function (index) {
    if (this.get_speed() > 0) {
      this.$element.flexslider("stop");
    }
    this.running = false;
    this.$element.flexslider(index);
  };

  this.start_animation = function () {
    this.running = true;
    // Don't start animation when autorotate is disabled
    if (this.get_speed() > 0) {
      this.$element.flexslider("play");
    }
  };

  this.on_slide_change = function (slider) {
    speed = this.get_speed();
    if (this.running && !slider.playing && speed > 0) {
      // restart autoscroll after given interval since last interaction
      clearTimeout(this.restartTimer);
      this.restartTimer = setTimeout(function () {
        slider.play();
      }, Math.max(0, SLIDER_REENABLE_INTERVAL - speed));
    }
  };

  this.configure = function (options) {
    var speed = this.get_speed();
    var $navigation = this.$element.parent().find(".custom-navigation");
    var opts = $.extend(
      {
        controlsContainer: $navigation,
        slideshowSpeed: speed,
        animation: this.get_animation(),
        slideshow: speed > 0,
        useCSS: false, // Fix for background disappearing: http://stackoverflow.com/a/27298397
        pauseOnAction: true,
        after: this.on_slide_change.bind(this),
        customDirectionNav: $navigation.find("a"),
      },
      DEFAULT_OPTIONS,
      options
    );
    this.$element.find("ul").width("auto");
    this.$element.flexslider(opts);
  };
  this.configure({});

  // flexslider stops the animation when the page is not focused, this breaks when the section is
  // changed in theme admin because it triggers 'blur' event when another iframe is selected
  $(window).unbind("blur");
}

function load_collection_tag_filter() {
  /* Product Tag Filters - Good for any number of filters on any type of collection pages */
  var collFilters = jQuery(".coll-filter");
  collFilters.on('change', function () {
    var newTags = [];
    collFilters.each(function () {
      var val = jQuery(this).val();
      if (val) {
        newTags.push(val);
      }
    });
    if (newTags.length) {
      var query = newTags.join("+");
      var link = $("#link-to-tag-generic").val();
      window.location.href = $("#link-to-tag-generic a")
        .attr("href")
        .replace("tag", query);
    } else {
      window.location.href = $("#link-to-collection").val();
    }
  });
}

var rellax_by_id = {};
var was_mobile = false;
var resize_handler = null;
var rellax_elements = [];

function apply_parallax(id) {
  var old_relax = rellax_by_id[id];
  if (old_relax) {
    old_relax.destroy();
  }
  rellax_by_id[id] = new Rellax("#" + id, {
    center: true,
    speed: -4,
  });
}

function parallaxes(apply) {
  Array.prototype.forEach.call(
    document.querySelectorAll(".rellax"),
    function (el) {
      el.style.transform = "translate3d(0,0,0)";
      if (apply) {
        apply_parallax(el.id);
      }
    }
  );
}

function load_parallax() {
  rellax_elements = document.querySelectorAll(".rellax");

  if (rellax_elements.length === 0) {
    // There is no rellax element
    return;
  }

  if ($(window).width() <= 768) {
    // No parallax on mobile
    was_mobile = true;
  } else {
    setTimeout(parallaxes.bind(null, true), 100);
  }

  if (resize_handler) {
    window.removeEventListener(resize_handler);
  }
  resize_handler = window.addEventListener("resize", function () {
    for (var key in rellax_by_id) {
      if (rellax_by_id.hasOwnProperty(key)) {
        var id = key;
        var rellax = rellax_by_id[key];
        rellax.destroy();
      }
    }
    rellax_by_id = {};
    setTimeout(function () {
      parallaxes($(window).width() > 768);
    }, 100);
  });
}

// Infinite scrolling

function Pagination() {
  // how many pixels from bottom should next page start loading
  this.PAGINATION_LOAD_OFFSET = 2400;
  // how often should the scroll position should be checked (in milliseconds)
  this.SCROLL_DELAY = 150;

  this.PAGINATION_SELECTOR = ".pagination";
  this.COLLECTION_MAIN_SELECTOR = ".collection-main-body-inner";
  this.COLLECTION_HEADER_SELECTOR = ".collection-main-central-header";
  this.COLLECTION_ITEM_SELECTOR = ".grid__item";
  this.COLLECTION_ITEM_EXCLUDE_SELECTOR =
    ".collection-central-description-block";

  this.$w = $(window);
  this.$doc = $(document);
  this.$collection = $(this.COLLECTION_MAIN_SELECTOR);
  this.$loading_indicator = $(".pagination-loading");
  this.loading = false;
  this.fully_loaded = false;
  this.scroll_timeout = null;

  this.scroll_handler = this.scroll_handler.bind(this);
  this.check_infinite_scroll = this.check_infinite_scroll.bind(this);
  this.install_scroll_handler();
}

Pagination.prototype.install_scroll_handler = function () {
  $(window).on("scroll", this.scroll_handler);
};

Pagination.prototype.uninstall_scroll_handler = function () {
  $(window).off("scroll", this.scroll_handler);
};

Pagination.prototype.scroll_handler = function () {
  if (this.scroll_timeout) {
    clearTimeout(this.scroll_timeout);
  }
  this.scroll_timeout = setTimeout(
    this.check_infinite_scroll,
    this.SCROLL_DELAY
  );
};

Pagination.prototype.check_infinite_scroll = function () {
  if (
    this.$doc.height() - this.PAGINATION_LOAD_OFFSET <
    this.$doc.scrollTop() + this.$w.height()
  ) {
    this.load_next_page();
  }
};

Pagination.prototype.set_loading = function (loading) {
  if (loading) {
    this.loading = true;
    this.$loading_indicator.show();
    $(this.PAGINATION_SELECTOR).hide();
  } else {
    this.loading = false;
    this.$loading_indicator.hide();
    $(this.PAGINATION_SELECTOR).show();
  }
};

Pagination.prototype.load_next_page = function () {
  if (this.loading) {
    return false;
  }
  var next_url = $(this.PAGINATION_SELECTOR)
    .find(".pagination-next a")
    .attr("href");
  if (!next_url || next_url === "#") {
    this.uninstall_scroll_handler();
    return;
  }
  this.set_loading(true);
  $.ajax({
    type: "GET",
    url: next_url,
    dataType: "html",
  })
    .done(this.page_loaded.bind(this))
    .always(this.set_loading.bind(this, false));
};

Pagination.prototype.page_loaded = function (data) {
  var data_dom = $(data);
  this.$collection.append(
    data_dom
      .find(
        this.COLLECTION_HEADER_SELECTOR + " > " + this.COLLECTION_ITEM_SELECTOR
      )
      .not(this.COLLECTION_ITEM_EXCLUDE_SELECTOR),
    data_dom.find(
      this.COLLECTION_MAIN_SELECTOR + " > " + this.COLLECTION_ITEM_SELECTOR
    )
  );
  $(this.PAGINATION_SELECTOR).replaceWith(
    data_dom.find(this.PAGINATION_SELECTOR)
  );

  // Add handlers for 'shop now' buttons
  load_shop_now();
  // Load reviews
  load_product_review_badges();
  load_quantity_selector();
  if (typeof ajaxCart !== "undefined") {
    ajaxCart.init({
      formSelector: "#AddToCartForm",
      cartContainer: "#CartContainerMini",
      addToCartSelector: "#AddToCart",
      cartCountSelector: "#CartCount",
      moneyFormat: window.Currency
        ? window.Currency.moneyFormats[window.Currency.shopCurrency]
            .money_format
        : window.default_currency_format,
    });
  }
};

var pagination = null;

function load_infinite_scroll() {
  if (pagination) {
    pagination.uninstall_scroll_handler();
    pagination = null;
  }

  var $pagination = $(".pagination-infinite");
  if ($pagination.length === 0) {
    return;
  }

  pagination = new Pagination();
}

// Base for all the secondary drawers, primary drawer is the Cart

function Drawer(container_selector, title_selector) {
  this.animation_duration = 800;
  this.$body = $("body");
  this.$drawer = $("#CartDrawer");
  this.$primary_container = $("#CartContainerMini");
  this.$primary_title = $("#CartTitle");
  this.$secondary_container = $(container_selector);
  this.$secondary_title = $(title_selector);

  this.$primary_group = this.$primary_container.add(this.$primary_title);
  this.$secondary_group = this.$secondary_container.add(this.$secondary_title);
}

Drawer.prototype.show_primary = function () {
  this.$secondary_group.addClass("hide");
  this.$primary_group.removeClass("hide");
};

Drawer.prototype.show_secondary = function () {
  this.$primary_group.addClass("hide");
  this.$secondary_group.removeClass("hide");
};

Drawer.prototype.open = function () {
  this.show_secondary();
  this.$body.one("afterDrawerClose.timber", this.close.bind(this));
  timber.RightDrawer.open();
  if (typeof BOLD !== "undefined") {
    if (
      BOLD &&
      BOLD.recurring_orders &&
      BOLD.recurring_orders.app &&
      BOLD.recurring_orders.app.productForms
    ) {
      if (BOLD.recurring_orders.app.productForms.indexOf(this) === -1) {
        if (typeof BOLD.recurring_orders.app.reboot === "function") {
          BOLD.recurring_orders.app.reboot();
        }
      }
    }
  }
};

Drawer.prototype.close = function () {
  // Show cart after the animation ends
  setTimeout(
    function () {
      this.show_primary();
    }.bind(this),
    this.animation_duration
  );
};

// Load Quick Shop in the Cart drawer

function ShopNow(url) {
  this.$body = $("body");
  this.drawer = new Drawer("#ShopNowContainer", "#ShopNowTitle");

  this.$body.on("afterAddItem.ajaxCart", this.animate_to_cart.bind(this));

  $.ajax({
    type: "GET",
    url: url,
    dataType: "html",
  })
    .done(this.page_loaded.bind(this))
    .error(function (error) {
      // FIXME: handle error correctly
      alert(error);
    });
}

ShopNow.prototype.page_loaded = function (data) {
  var data_dom = $(data);
  var product_single = data_dom.find(".product-single");

  // We don't want to see reviews
  product_single.find("#shopify-product-reviews").remove();
  // We want to see mobile slider instead of desktop version
  product_single.find(".product-single__photos").hide();
  product_single.find("#product-images-mobile").removeClass("large--hide");

  // Replace product html content
  var container = this.drawer.$secondary_container;
  container.find(".product-single").remove();
  container.append(product_single);

  // Replace product JSON
  container.find("#ProductJson-product-template").remove();
  container.append(data_dom.find("#ProductJson-product-template"));

  load_quantity_selector();
  load_option_selectors(container[0]);
  load_tabs();
  load_swatches();

  if (typeof ajaxCart !== "undefined") {
    ajaxCart.init({
      formSelector: "#AddToCartForm",
      cartContainer: "#CartContainerMini",
      addToCartSelector: "#AddToCart",
      cartCountSelector: "#CartCount",
      moneyFormat: window.Currency
        ? window.Currency.moneyFormats[window.Currency.shopCurrency]
            .money_format
        : window.default_currency_format,
    });
  }

  this.drawer.open();
};

// Fade in animation between Quick Shop and Cart
ShopNow.prototype.animate_to_cart = function () {
  this.$body.one(
    "afterCartLoad.ajaxCart",
    function () {
      timber.RightDrawer.close();
      setTimeout(
        function () {
          this.drawer.show_primary();
          timber.RightDrawer.open();
          this.drawer.$drawer.scrollTop(0);
        }.bind(this),
        this.drawer.animation_duration
      );
    }.bind(this)
  );
};

function shop_now_handler(e) {
  var url = $(this).attr("href");
  new ShopNow(url);
  return false;
}

function load_shop_now() {
  $(".shop-now-button")
    .off("click", shop_now_handler)
    .on("click", shop_now_handler);
}

// Load Log In in the Cart drawer

function LogInDrawer(url) {
  this.drawer = new Drawer("#LogInContainer", "#LogInTitle");

  this.$body = $("body");

  $.ajax({
    type: "GET",
    url: url,
    dataType: "html",
  })
    .done(this.page_loaded.bind(this))
    .error(function (error) {
      // FIXME: handle error correctly
      alert(error);
    });
}

LogInDrawer.prototype.page_loaded = function (data) {
  var data_dom = $(data);
  var main_content = data_dom.find(".main-content");
  main_content.find(".login-form-cancel").remove();
  main_content.find(".sitewide--title-wrapper").remove();
  this.drawer.$secondary_container.empty().append(main_content);

  // Bind recover password button
  timber.cacheSelectors();
  timber.loginForms();

  this.drawer.open();
};

function log_in_handler(e) {
  var url = $(this).attr("href");
  new LogInDrawer(url);
  return false;
}

function load_log_in() {
  $(".log-in-button").off("click", log_in_handler).on("click", log_in_handler);
}

function SearchDrawer() {
  this.drawer = new Drawer("#SearchContainer", "#SearchTitle");
  this.drawer.open();
  this.section_by_type = {
    article: "Articles",
    page: "Pages",
    product: "Products",
  };
  this.current_xhr = null;
  this.onchange_timer = null;

  this.$results = $("#search-results");
  var source = $("#LiveSearchResultTemplate").html();
  this.template = Handlebars.compile(source);

  var self = this;
  $("#search-input").bind("keyup change", function () {
    self.onchange($(this).val());
  });
  $("#search-input").focus();
}

SearchDrawer.prototype.onchange = function (query) {
  if (this.onchange_timer) {
    clearTimeout(this.onchange_timer);
  }
  this.onchange_timer = setTimeout(
    this.onchange_throttled.bind(this, query),
    200
  );
  if (this.current_xhr) {
    this.current_xhr.abort();
  }
};

SearchDrawer.prototype.get_search_url = function (query, json) {
  var types = "product,article,page";
  var view = "";
  if (json) {
    view = "&view=json";
  }
  return "/search?type=" + types + view + "&q=" + encodeURIComponent(query);
};

SearchDrawer.prototype.onchange_throttled = function (query) {
  var url = this.get_search_url(query, true);
  this.$results.empty();
  this.$results.append(
    '<i class="fa fa-circle-o-notch fa-spin fa-fw"></i><span class="sr-only">Loading...</span>'
  );

  this.current_xhr = $.getJSON(url)
    .done(this.show_results.bind(this))
    .fail(this.show_error.bind(this))
    .always(
      function () {
        this.current_xhr = null;
      }.bind(this)
    );
};

SearchDrawer.prototype.show_results = function (data) {
  var $show_more = $("#search-show-more");
  $show_more.addClass("hide");
  this.$results.empty();
  var results_by_type = {};
  data.results.forEach(function (result) {
    if (results_by_type.hasOwnProperty(result.type)) {
      results_by_type[result.type].push(result);
    } else {
      results_by_type[result.type] = [result];
    }
  });

  if (data.terms) {
    if (data.results.length > 0) {
      this.$results.append(
        "<p>" +
          SearchTranslations.results_for_html.replace(
            /\{\{\s*terms\s*\}\}/g,
            data.terms
          ) +
          "</p>"
      );
      for (var type in results_by_type) {
        if (results_by_type.hasOwnProperty(type)) {
          this.$results.append("<h2>" + this.section_by_type[type] + "</h2>");
          results_by_type[type].forEach(this.show_result.bind(this));
        }
      }
      if (data.has_more) {
        $show_more
          .removeClass("hide")
          .attr("href", this.get_search_url(data.terms, false));
      }
      if (window.Currency) {
        window.Currency.convertAll(
          window.Currency.shopCurrency,
          window.Currency.currentCurrency
        );
      }
    } else {
      this.$results.append(
        "<p>" +
          SearchTranslations.no_results_html.replace(
            /\{\{\s*terms\s*\}\}/g,
            data.terms
          ) +
          "</p>"
      );
    }
  }
};

SearchDrawer.prototype.show_result = function (result) {
  this.$results.append(this.template(result));
};

SearchDrawer.prototype.show_error = function (error) {
  if (error.statusText === "abort") {
    return;
  }
  console.error("statusText", error.statusText);
  console.error("error", JSON.stringify(error));
  // We'll redirect the user to /search page when search fails (for whatever reason)
  var query = $("#search-input").val();
  window.location = this.get_search_url(query, false);
};

function search_handler(e) {
  new SearchDrawer();
  $("#search-input").focus();
  return false;
}

function load_search_drawer() {
  $(".search-button").off("click", search_handler).on("click", search_handler);
}

$(document).ready(function () {
  load_imageZoomEvents();
  checkSidebarSticky();
});

function load_imageZoomEvents() {
  //page load
  loadImageZoom();

  //responsive check
  $(window).on("resize", function () {
    loadImageZoom();
  });
}

function loadImageZoom() {
  //only tablet and up
  if ($(window).width() > 768) {
    $(".product-single__photo-wrapper img.product-single__photo").hoverIntent(
      hoverZoomIn,
      hoverZoomOut
    );
  } else {
    // kill all zoom events if we re-size below tablet
    $(".product-single__photo").each(function (index, image) {
      $(image).trigger("zoom.destroy"); // remove zoom
    });
  }
}

function hoverZoomIn(event) {
  var image = $(this);

  var imageZoomEnabled = image.data().imageZoomEnable;

  var alreadyLoaded = image.hasClass("js__image_already_loaded");

  var smallImage = image.hasClass("js__smallImage");

  // only if image-zoom enabled
  if (imageZoomEnabled == true && !alreadyLoaded && !smallImage) {
    image.css({ opacity: 0.5 });

    var imageZoom = image.data().imageZoom;

    var imageParent = image.closest(".product-single__photo-wrapper");

    var imageZoomLoader = imageParent
      .find("#featured-image-loader")
      .fadeIn("fast");

    $(this)
      .delay(500)
      .queue(function () {
        imageParent.css("display", "inline-block").zoom({
          url: imageZoom,
          callback: function () {
            //fires when the zoomed image has finished loading

            image.addClass("js__image_already_loaded");
            imageZoomLoader.fadeOut("slow");
            // slight quirk means we need to re-fire the mouseover event to actually see the image.
            image.trigger("mouseover");
          },
        });
      });
  }
}

function hoverZoomOut() {
  var image = $(this);

  image.css({ opacity: 1 });
}

if ($("#shopify-product-reviews").length > 0) {
  var $productReviewsPlaceholder = $(".desktop_review_placeholder");
  var $productReviews = $(
    "#shopify-product-reviews",
    $productReviewsPlaceholder
  );
  var $productReviewsClone = $productReviews.clone();

  moveProductReviews($productReviewsClone);

  $(window).on("resize", function () {
    moveProductReviews($productReviewsClone);
  });
}

function moveProductReviews($productReviews) {
  if ($(window).width() < 768) {
    $(".mobile_review_placeholder").append($productReviews);
  } else {
    $(".mobile_review_placeholder #shopify-product-reviews").remove();
  }
}

load_TextAdvertCarousel();

function load_TextAdvertCarousel() {
  /*
    if($('.text-advert-section').length > 0){

        $(".text-advert-section .slides").addClass('owl-carousel owl-theme').owlCarousel({
            items: 1,
            autoHeight: true
        });
    }
    */
}

jQuery.fn.lengthWarn = function (number) {
  if (this.length > number)
    console.warn(
      "Length of " +
        this.selector +
        " was greater than " +
        number +
        ".  You've been warned.",
      this
    );
  if (this.length < number)
    console.warn(
      "Length of " +
        this.selector +
        " was less than " +
        number +
        ".  You've been warned.",
      this
    );
  return this;
};

// only need above code if loading products dynamically...and would want to use ajax
$(document).ready(function () {
  $(".title-container").matchHeight();
  $(".lazyload-img").unveil();
});

// rewrite candidate below...
if ($(".product-single").length > 0) {
  $(".categories h4").on("click", handleProductTabClicks);
}

function handleProductTabClicks() {
  var category = "." + this.textContent.toLowerCase();
  $("h4.active").removeClass("active");
  $(this).addClass("active");
  $(".ingredients, .nutrition, .details").addClass("hide");
  $(category).removeClass("hide");
}

$(".js-qty__num").on("change", function () {
  $(this).closest("td").find(".update").addClass("need-to-update");
});
$(".js-qty__adjust").on("click", function () {
  $(this).closest("td").find(".update").addClass("need-to-update");
});
$(".mobile-nav__has-sublist>a").on("click", function () {
  $(this)
    .siblings(".mobile-nav__toggle")
    .find(".mobile-nav__toggle-open")
    .click();
});

jQuery(function () {
  $(".site-header__cart-toggle").hover(function () {
    ajaxCart.load();
     helper();

  });

  // product reviews
  $(".product-head-wrapper .yotpo.bottomLine").on("click", function (e) {
    if (!e) var e = window.event;
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    $("html, body").animate(
      {
        scrollTop: $(".yotpo-reviews").offset().top,
      },
      1000
    );
  });

  // filter collections add title
  $(".filter-wrap label input:checked").each(function () {
    var addTitle = $(this).val();
    var curTitle = $(".collection-sidebar__title")
      .html()
      .toLowerCase()
      .replace(" ", "-");
    if (addTitle != curTitle) {
      $(".collection-sidebar__title").append(" + " + addTitle);
    }
  });
});

(function ($) {
  // IIFE wrap begin

  function ExecuteCatFiltersWhenReady(configuration) {
    configuration = configuration || {};
    console.log('Execute Running');
    this.interval = null;
    this.queries = []; // contains objects which query the DOM and conditionally keep resulting jQuery element(s)
    this.add = function (selector, test) {
      // add new object to query
      var testFunction = function () {
        var $el = $(selector);
        if (typeof test === "number") {
          return $el.length === test ? $el : null;
        } else if (typeof test === "function") {
          return test($el) ? $el : null;
        }
      };
      this.queries.push({
        testFunction: testFunction,
        $result: null,
      });
      return this;
    };
    this.execute = function (fn) {
      // start an interval with code to executer when all queries are ready
      var self = this;
      var intervalFunction = function () {
        // update query if necessary
        self.queries = self.queries.map(function (query, idx) {
          var result = query.testFunction();
          // Debug: log selector and result
          if (!result) {
            console.warn("ExecuteCatFiltersWhenReady: Selector not ready at index", idx, query, result);
          }

          if (!query.$result || configuration.isContinuous) {
            query.$result = query.testFunction();
          }
          return query;
        });
        var $results = self.queries.map(function (query) {
          return query.$result;
        });
        // check if all elements ready
        if (
          $results.every(function ($result) {
            return $result !== null;
          })
        ) {
          // execute provided function
          try {
            var args = $results.concat(self);

            fn.apply(null, args);
          } catch (err) {
            console.log(configuration);
            console.error(
              "Function passed to ExecuteCatFiltersWhenReady did not completely execute.\n",
              err
            );
            self.stop();
          }
          if (!configuration.isContinuous) self.stop();
        }
      };
      self.interval = setInterval(intervalFunction, configuration.speed || 100);
      intervalFunction();
      return this;
    };
    this.stop = function () {
      // stops interval
      clearInterval(this.interval);
      return this;
    };
  }

  // "Globals"
  // -------

  // Functions
  // ---------

  // Select dropdown checkbox
  var expanded = false;
  function showfiltercheckboxes() {
    var $checkboxes = $("#checkboxes");
    if (!expanded) {
      $checkboxes.css("display", "block");
      expanded = true;
    } else {
      $checkboxes.css("display", "none");
      expanded = false;
    }
  }
  function showfiltercheckboxesOne() {
    var $checkboxes = $("#checkboxesOne");
    if (!expanded) {
      $checkboxes.css("display", "block");
      expanded = true;
    } else {
      $checkboxes.css("display", "none");
      expanded = false;
    }
  }

  // Logic/Execution
  // ---------------
if (jQuery(".collection-main-body").length > 0) {
  var ewrAddSidebarFilter = new ExecuteCatFiltersWhenReady()
    .add(".grid__item.large--three-quarters.collection-main-body", 1)
    .add(".grid__item.large--three-quarters .section-header", 1)
    .add('.collection-sidebar-filter:contains("Filter")', 1)
    .add(
      ".grid__item.large--one-quarter.collection-sidebar-wrapper.collection-sidebar-mobile-wrapper",
      1
    )
    .add(undefined, function (_) {
      try {
        jQuery();
        return true;
      } catch (err) {
        return false;
      }
    })
    .execute(function (
      $productGrid,
      $sidebarDescription,
      $sidebarFilter,
      $sidebar
    ) {
      // Use client's jquery
      console.log("Using client jQuery");
      var $ = jQuery;

      // New variable setup. Move mobile filter above product grid
      var $filterWrap = $(".filter-wrap");
      var $filterWrapMobile = $(".filter-wrap-mobile");

      // Convert existing select dropdown into checkboxes
      var $sidebarSelect = $sidebar.find("select");
      $sidebarSelect.each(function (i, select) {
        var $select = $(select);
        $select.find("option").each(function (j, option) {
          var $option = $(option);
          // Create a input checkbox:
          var $input = $('<input type="checkbox" />');
          $input
            .attr("name", $option.val())
            .attr("value", $option.val())
            .attr("id", $option.val());
          // Set checked if the option was selected
          if ($option.attr("selected")) $input.attr("checked", "checked");
          // Insert radio before select box:
          $select.before($input);
          // Insert a label:
          $select.before(
            $("<label ></label>")
              .attr("for", $option.val())
              .text($option.text())
              .attr("id", $option.val())
              .attr("data-value", $option.val())
              .append('<span class="checkmark"></span>')
          );
        });
        $select.hide(); // hide original select filter
      });

      // If input is clicked, then trigger the original select dropdown to initiate url change
      var $select = $sidebarFilter.find("select"), value = "";
      console.log("Select Val" + $select.val());
      var $selectVal = $select.val();
      if ($selectVal != null && $("p.empty-collection").length > 0) {
        $("p.empty-collection").html(
          'We\'re sorry, but no products match the filters you have set. Please deselect a filter, or <a href="#" class="reset-coll-filters">Reset Filters.</a>'
        );
      }
      // var $select = $sidebarFilter.find('input:checked'), value = "";

      // Get last url keyword. This will be used to match keyword with input ID for checkbox persistence
      var $url = $(location).attr("href");
      var $parts = $url.split("/");
      var $last_url_keyword = $parts[$parts.length - 1];
      var $last_url_array = $last_url_keyword.split(",");

      // Get current input with matching id with $last_url_keyword. And add checked attribute to to input if label is clicked
      $.each($last_url_array, function (index, value) {
        var useValue = value.split("?")[0];
        // only select characters before a + sign in usevalue
        useValue = useValue.split("+")[0];
        var $currentFilter = $filterWrap.find("input[id = " + useValue + "]");
        if (!$currentFilter.attr("checked"))
          $currentFilter.attr("checked", "true");
      });

      // Move inputs inside label for styling purposes
      var $inputAll = $sidebarFilter.find('input[type="checkbox"]');
      $inputAll.each(function () {
        var item = $(this);
        item.next().prepend(item);
      });

      // Hide label containing 'all products' text
      var allProductsLabel = $sidebarFilter.find(
        'label:contains("All products")'
      );
      allProductsLabel.hide();

      // Add class to nutrition only labels
      var $nutritionLabel = $sidebarFilter.find(
        'label:contains("gluten free"), label:contains("nut free"), label:contains("low carb"), label:contains("dairy free"), label:contains("vegan"), label:contains("vegetarian"), label:contains("plant"), label:contains("keto"), label:contains("paleo"), label:contains("spicy"), label:contains("whole30"), label:contains("anti-inflammatory"), label:contains("diabetic friendly"), label:contains("muscle building")'
      );
      $nutritionLabel.addClass("nutrition");

      // Move nutrition filters to nutrition section
      var $filterNutrition = $(".filter-nutrition");
      var $nutritionClass = $sidebarFilter.find(".nutrition");
      $filterNutrition.append($nutritionClass);

      // Move protein filters to protein section
      var $filterProteins = $(".filter-proteins");
      var $proteinLabel = $sidebarFilter.find("label").not("nutrition");
      $filterProteins.append($proteinLabel);

      // Switch case to pre-select 'nutrition need' filter to be checked when user arrives at corresponding category
      switch (window.location.pathname) {
        case "/collections/pre-made-low-carb-meals":
          var $currentFilter = $filterWrap.find("input[id = low-carb]");
          if (!$currentFilter.attr("checked"))
            $currentFilter.attr("checked", "true");
          break;
        case "/collections/gluten-free":
          var $currentFilter = $filterWrap.find("input[id = gluten-free]");
          if (!$currentFilter.attr("checked"))
            $currentFilter.attr("checked", "true");
          break;
        case "/collections/dairy-free":
          var $currentFilter = $filterWrap.find("input[id = dairy-free]");
          if (!$currentFilter.attr("checked"))
            $currentFilter.attr("checked", "true");
          break;
        case "/collections/vegan":
          var $currentFilter = $filterWrap.find("input[id = vegan]");
          if (!$currentFilter.attr("checked"))
            $currentFilter.attr("checked", "true");
          break;
        case "/collections/plant-based":
          var $currentFilter = $filterWrap.find("input[id = plant-based]");
          if (!$currentFilter.attr("checked"))
            $currentFilter.attr("checked", "true");
          break;
      }

      // Protein filter should only show up in these categories and its child categories
      if (
        window.location.href.indexOf("/collections/pre-made-low-carb-meals") >
        -1
      )
        $filterProteins.hide();
      else if (window.location.href.indexOf("/collections/gluten-free") > -1)
        $filterProteins.hide();
      else if (window.location.href.indexOf("/collections/dairy-free") > -1)
        $filterProteins.hide();
      else if (window.location.href.indexOf("/collections/bulk") > -1)
        $filterProteins.show();
      else if (window.location.href.indexOf("/collections/all-menu-items") > -1)
        $filterProteins.show();
      else if (
        window.location.href.indexOf(
          "/collections/healthy-pre-made-meals-for-lunch-and-dinner"
        ) > -1
      )
        $filterProteins.show();
      else if (
        window.location.href.indexOf(
          "/collections/healthy-pre-made-salads-wraps-soups"
        ) > -1
      )
        $filterProteins.show();

      // Clone filter and append to mobile element. Need to do this to retain attached events.
      var $sidebarFilterLabel = $filterWrap.find("label");
      // leave .clone blank so it doesn't clone the onclick events...
      var $clone = $sidebarFilterLabel.clone();
      $clone.find(".coll-filter").remove();
      $clone.find("[id]").each(function() {
        var originalId = $(this).attr("id");
        var newId = originalId + "-2";
        $(this).attr("id", newId);
      });
      $clone.appendTo($(".filter-nutrition"));
      $filterWrapMobile.append($clone);

      // Move nutrition filters to nutrition mobile section
      console.log("Moving nutrition filters to mobile section");
      var $filterNutritionMobile = $(".filter-nutrition-mobile");
      var $nutritionClassMobile = $filterWrapMobile.find(".nutrition");
      $filterNutritionMobile.append($nutritionClassMobile);

      // Move protein filters to protein mobile section
      var $filterProteinsMobile = $(".filter-proteins-mobile");
      var $proteinLabelMobile = $filterWrapMobile
        .find("label")
        .not(".nutrition");
      $filterProteinsMobile.append($proteinLabelMobile);

      // Move mobile protein labels in select box
      var $proteinsCheckbox = $filterWrapMobile.find(
        ".filter-proteins-mobile #checkboxes"
      );
      $proteinsCheckbox.append($proteinLabelMobile);

      // Move mobile nutrition labels in select box
      var $nutritionLabelMobile = $filterWrapMobile.find(
        'label:contains("gluten free"), label:contains("nut free"), label:contains("low carb"), label:contains("dairy free"), label:contains("vegan"), label:contains("vegetarian"), label:contains("plant"), label:contains("keto"), label:contains("paleo"), label:contains("whole30"), label:contains("anti-inflammatory"), label:contains("diabetic friendly"), label:contains("muscle building")'
      );
      var $nutritionCheckbox = $filterWrapMobile.find(
        ".filter-nutrition-mobile #checkboxesOne"
      );
      $nutritionCheckbox.append($nutritionLabelMobile);

      // Open/hide select options for protein filter
      var $proteinSelect = $filterWrapMobile.find(
        ".filter-proteins-mobile .selectBox"
      );
      $proteinSelect.on("click", function () {
        showfiltercheckboxes();
      });

      // Open/hide select options for nutrition filter
      var $nutritionSelect = $filterWrapMobile.find(
        ".filter-nutrition-mobile .selectBox"
      );
      $nutritionSelect.on("click", function () {
        showfiltercheckboxesOne();
      });

      // Find id of input that is checked and update select text with id of checked input
      var $findCheckedInputIDProtein = $filterWrapMobile
        .find(".filter-proteins-mobile input:checked")
        .attr("id");
      var $currentProteinSelect = $filterWrapMobile.find(
        '.filter-proteins-mobile option[value="default"]'
      );
      $currentProteinSelect.text($findCheckedInputIDProtein);

      var $findCheckedInputIDNutrition = $filterWrapMobile
        .find(".filter-nutrition-mobile input:checked")
        .attr("id");
      var $currentNutritionSelect = $filterWrapMobile.find(
        '.filter-nutrition-mobile option[value="default"]'
      );
      $currentNutritionSelect.text($findCheckedInputIDNutrition);

      // Protein filter should only show up in these categories and its child categories
      if (
        window.location.href.indexOf("/collections/pre-made-low-carb-meals") >
        -1
      )
        $filterProteinsMobile.hide();
      else if (window.location.href.indexOf("/collections/gluten-free") > -1)
        $filterProteinsMobile.hide();
      else if (window.location.href.indexOf("/collections/dairy-free") > -1)
        $filterProteinsMobile.hide();
      else if (window.location.href.indexOf("/collections/bulk") > -1)
        $filterProteinsMobile.show();
      else if (
        window.location.href.indexOf(
          "/collections/healthy-pre-made-meals-for-lunch-and-dinner"
        ) > -1
      )
        $filterProteinsMobile.show();
      else if (
        window.location.href.indexOf(
          "/collections/healthy-pre-made-salads-wraps-soups"
        ) > -1
      )
        $filterProteinsMobile.show();

      // hide redundancies
      if (window.location.href.indexOf("collections/diabetic-friendly") > -1) {
        $(".filter-nutrition #diabetic-friendly").hide();
      } else if (
        window.location.href.indexOf("collections/muscle-building") > -1
      ) {
        $(".filter-nutrition #muscle-building").hide();
      }

      // Close select dropdown on click away
      
      $(document).on("mouseup", function (e) {
        if (
          !$proteinsCheckbox.is(e.target) &&
          $proteinsCheckbox.has(e.target).length === 0
        )
          $proteinsCheckbox.hide();
        if (
          !$nutritionCheckbox.is(e.target) &&
          $nutritionCheckbox.has(e.target).length === 0
        )
          $nutritionCheckbox.hide();
      });

      
      $(document).on('click', '.filter-wrap label, .filter-wrap-mobile label', function() {
        console.log('sidebarfilterlabel');
        
        var selectedValue = $(this).attr("data-value");
        if ($('.coll-filter option[value="' + selectedValue + '"]').attr("selected") == "selected") {
          $('.coll-filter option[value="' + selectedValue + '"]').prop("selected",false);
        } else {
          $('.coll-filter option[value="' + selectedValue + '"]').prop("selected",true);
        }
      
        console.log('click event on sidebar')
        $select.get(0).dispatchEvent(new Event("change"));
    });


      // Remove seasonal label
      var $seasonalLabel = $("label#seasonal");
      $seasonalLabel.remove();
    }); // end
}

  $(".reset-coll-filters").on("click", function () {
    resetCollFilters();
  });
  function resetCollFilters() {
    $(".coll-filter option").prop("selected", false);
    $(".coll-filter").get(0).dispatchEvent(new Event("change"));
  }

  // Force product fadein to not work
  var scrollPrepEWR = new ExecuteCatFiltersWhenReady().add("html, body", 2).execute(function ($htmlAndBody) {
      var currentScroll = $htmlAndBody.scrollTop();
      $htmlAndBody.scrollTop($(document).height()).scrollTop(currentScroll);
  }); // end
})($);

function sortCollectionByCustom(param) {
  var divList = $(".collection-main-body-inner .grid__item");
  divList.sort(function (a, b) {
    switch (param) {
      case "cal-high":
        return $(b).data("calories") - $(a).data("calories");
      case "cal-low":
        return $(a).data("calories") - $(b).data("calories");
      case "protein-high":
        return $(b).data("protein") - $(a).data("protein");
      case "protein-low":
        return $(a).data("protein") - $(b).data("protein");
      case "carbs-high":
        return $(b).data("carbs") - $(a).data("carbs");
      case "carbs-low":
        return $(a).data("carbs") - $(b).data("carbs");
      case "sodium-high":
        return $(b).data("sodium") - $(a).data("sodium");
      case "sodium-low":
        return $(a).data("sodium") - $(b).data("sodium");
      case "price-high":
        return $(b).data("price") - $(a).data("price");
      case "price-low":
        return $(a).data("price") - $(b).data("price");
      case "fat-low":
        return $(a).data("fat") - $(b).data("fat");
      case "fat-high":
        return $(b).data("fat") - $(a).data("price");
      default:
        // Handle the default case here
    }
  });
  $(".collection-main-body-inner").html(divList);
  $(".grid__item,.grid__item img").css("visibility", "visible");
  $(".grid__item").css("animation-name", "fadeInUp");
}

$("#sorting-hat").on("change", function () {
  sortCollectionByCustom($("#sorting-hat").val());
});

function mobileFilterLaunch() {
  timber.RightDrawer.open();
  var filterHTML =
    '<div class="drawer__close filter-drawer-close js-drawer-close"><button type="button" class="icon-fallback-text"><i class="fa fa-times fa-lg" aria-hidden="true"></i><span class="fallback-text">"Close Cart"</span></button></div>' +
    $(".collection-sidebar-wrapper").html();
  $("#CartDrawer").html(filterHTML);
  $(".filter-drawer-close").on("click", function () {
    timber.RightDrawer.close();
  });
}
